import React, { memo } from 'react';

import { LoadingSpinStyle } from './style';

// eslint-disable-next-line react/prop-types
export default memo(({ show, ...options }) => show && <LoadingSpinStyle {...options} />);
